import { render, staticRenderFns } from "./InboxReports.vue?vue&type=template&id=6c30dd8c"
import script from "./InboxReports.vue?vue&type=script&lang=js"
export * from "./InboxReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports